export const calcAddOnPrice = ({
  addOnPrice,
  isPerStudyPricing,
  selectedStudiesCount,
  quantity = 1,
}: {
  addOnPrice: number;
  isPerStudyPricing: boolean;
  selectedStudiesCount: number;
  quantity?: number;
}): number => {
  const unitTotal = isPerStudyPricing
    ? addOnPrice * Math.max(selectedStudiesCount, 1)
    : addOnPrice;

  return unitTotal * quantity;
};
